export default {"src":"/_next/static/media/event_upcoming_white.42c2d349.svg","height":12,"width":13,"blurWidth":0,"blurHeight":0};